module['exports'] = ['گھر. ###', 'گلی ###'];
